<!--Copyright (c) Method Development, LLC.  All rights reserved.-->

{#if message != null}
<!-- svelte-ignore component-name-lowercase -->
<notify aria-label="informational" role="alert" class="{active ? 'notify-visible' : 'notify-hidden' }">
    {message}
</notify>
{/if}

<script>
    import { notify } from "../lib/store.js";
    import { onDestroy } from "svelte";

    let message = null;
    let defaultTimeout = 2500;
    let active = false;

    const trigger = (data) => {
        if (active === true) return;
        if (data.message == null || data.message == undefined) return;

        if (data.message) {
            message = data.message;
            active = true;

            if (!data.timeout) data.timeout = defaultTimeout;

            setTimeout(close, data.timeout);
        }
    };

    const close = () => {
        active = false;

        //delay on .notify-visible or .notify-hidden is 1s
        setTimeout(() => {
            message = null;
        }, 1000);
    };

    const unsubscribe = notify.subscribe((data) => {
        trigger(data);
    });

    onDestroy(unsubscribe);
</script>